import { Component, OnInit, Input } from '@angular/core';
import { ShippingAddress } from '../../../../models/check-out.model';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../../services/checkout.service';
import { AccountDeliveryAddress } from '../../../../models/account-delivery-address';

@Component({
  selector: 'app-delivery-summary',
  templateUrl: './delivery-summary.component.html',
  styleUrls: ['./delivery-summary.component.css']
})
export class DeliverySummaryComponent implements OnInit {

  @Input() deliverySummary: ShippingAddress;
  @Input() enableEdit: boolean;
  deliveryAddress: AccountDeliveryAddress;
  deliveryPickup:string

  constructor(private router: Router
    , private activatedRoute: ActivatedRoute
    , private checkOutService: CheckOutService) { }

  ngOnInit() {
    this.deliveryPickup = localStorage.getItem('DeliveryMethod')
  }

  editDelivery(): void {
    this.deliveryAddress = {    
      warehouseName:this.deliverySummary.WarehouseName,
      companyName: this.deliverySummary.companyName,
      attnOrRef: this.deliverySummary.attnRef,
      addressLine1: this.deliverySummary.addressLine1,
      addressLine2: this.deliverySummary.addressLine2,
      addressLine3: this.deliverySummary.addressLine3,
      suburb: this.deliverySummary.suburb,
      state: this.deliverySummary.state,
      postcode: this.deliverySummary.postcode,
      phone: this.deliverySummary.phone,
      naType: this.deliverySummary.salesTypeTab,
      action: 'U',
      combinedAddress: ''
     //warehouseName: this.deliverySummary.WarehouseName
    };
    this.checkOutService.monitorEditAddress(this.deliveryAddress);
    this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute.parent });
  }

}
